export default __webpack_public_path__ + "static/media/seminar (2).51e99a87.JPG";